import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { consumeTheme } from '../../utils/theme';
import Input from '../Input';
import Keep from '../Dropdown/Keep';
var MenuInput = (function (_super) {
    __extends(MenuInput, _super);
    function MenuInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, className = _a.className, inputClassName = _a.inputClassName, prefixCls = _a.prefixCls, containerClassName = _a.containerClassName, containerStyle = _a.containerStyle, prefix = _a.prefix, postfix = _a.postfix, rest = __rest(_a, ["className", "inputClassName", "prefixCls", "containerClassName", "containerStyle", "prefix", "postfix"]);
            var cls = classNames(prefixCls, className);
            var inputCls = classNames(prefixCls + "-input", inputClassName);
            var containerCls = classNames(prefixCls + "-container", containerClassName);
            var prefixDomCls = classNames(prefixCls + "-prefix");
            var postfixDomCls = classNames(prefixCls + "-postfix");
            return (h(Keep, { className: containerCls, style: containerStyle },
                prefix && h("div", { className: prefixDomCls }, prefix),
                h(Input, __assign({ className: cls, inputClassName: inputCls }, rest)),
                postfix && h("div", { className: postfixDomCls }, postfix)));
        };
        return _this;
    }
    MenuInput.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return MenuInput;
}(React.Component));
export default MenuInput;
MenuInput.defaultProps = {
    prefixCls: 'dui-menu-input',
};
